module.exports = __webpack_public_path__ + "img/29.400bd369.png";